import { Consultation, CONSULTATION_STATUS, CONSULTATION_TYPE } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { ConsultationContext, ConsultationContextProps } from '@/contexts/consultation'
import { useConsultationType } from '@/hooks/useConsultationType'

const MAX_FOLLOW_UP_QUESTIONS = 3

interface UseConsultationProps {
  consultation: ConsultationContextProps['consultation']
  updateConsultation: (consultation: Consultation | null) => void
  isFollowUp: boolean
  canDoFollowUp: boolean
}

export const useConsultation = (): UseConsultationProps => {
  const { consultation, setConsultation } = useContext(ConsultationContext)
  const { consultationType } = useConsultationType()

  const updateConsultation = (consultation: Consultation | null) => {
    setConsultation(consultation)
  }

  const canDoFollowUp =
    Boolean(!consultation?.questions || consultation?.questions?.length < MAX_FOLLOW_UP_QUESTIONS) &&
    ![CONSULTATION_TYPE.PRESCRIPTION, CONSULTATION_TYPE.VIDEO, CONSULTATION_TYPE.MENTAL].includes(consultationType as CONSULTATION_TYPE) &&
    !consultation?.medicalAdvice?.isUrgencyViewed

  const isFollowUp = Boolean(consultation?.status === CONSULTATION_STATUS.RESOLVED && consultation?.questions?.length)

  return {
    consultation,
    updateConsultation,
    isFollowUp,
    canDoFollowUp
  }
}
